import React, { useState, useEffect } from "react";
import Icone from './util/Icone';
import { faBars, faTimes } from './util/icones';
import logo from '../assets/logo.webp';
import logo352 from '../assets/logo-352.webp';
import { whatsappUrl } from './util/whatsappUrl';
import { trackWhatsapp } from './util/analytics';

const links = [
  { href: "/", label: "Início" },
  { href: "/#services", label: "Serviços" },
  { href: "/#missao-visao-valores", label: "Sobre nós" },
  { href: "/perguntas-frequentes", label: "Dúvidas" },
];

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <header className="fixed px-8 bg-white z-50 w-full">
      <nav className="w-11/12 mx-auto py-6 flex justify-between items-center">
        <div>
          <a href="/" className="inline-block">
            <img src={logo}
            srcSet={`${logo352} 352w, ${logo} 640w`}
            sizes="(min-width: 1280px) 176px, 128px" alt="Hawx Soluções" width="640" height="206" className="w-32 xl:w-44 h-auto" />
          </a>
        </div>

        <div className="md:hidden">
          <button
            className="text-black hover:text-gray-500 focus:outline-none p-2"
            onClick={toggleMobileMenu}
            aria-label={isMobileMenuOpen ? "Fechar menu" : "Abrir menu"}
          >
            <Icone icon={isMobileMenuOpen ? faTimes : faBars} className="text-xl" />
          </button>
        </div>

        <ul className="hidden md:flex space-x-4 items-center">
          {links.map((link) => (
            <li key={link.href}>
              <a href={link.href} className="text-black hover:text-gray-500 font-medium">
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href={whatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsapp("menu")}
              className="bg-pattern-dark text-white font-medium px-5 py-2.5 rounded-xl hover:brightness-95 transition"
            >
              Contato
            </a>
          </li>
        </ul>

        <div
          className={`fixed inset-0 bg-pattern z-40 transform ${
            isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
          } transition-transform duration-300 ease-in-out`}
        >
          <button
            className="absolute top-6 right-6 text-white text-3xl focus:outline-none"
            onClick={toggleMobileMenu}
            aria-label="Fechar menu"
          >
            <Icone icon={faTimes} />
          </button>

          <ul className="flex flex-col items-center justify-center h-screen">
            {links.map((link) => (
              <li key={link.href} className="mb-8">
                <a
                  href={link.href}
                  className="text-white text-3xl font-display font-semibold hover:text-gray-200 block"
                  onClick={toggleMobileMenu}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="mb-8">
              <a
                href={whatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackWhatsapp("menu-mobile")}
                className="bg-secondary text-black text-xl font-semibold px-8 py-4 rounded-2xl hover:brightness-95 transition block"
              >
                Contato
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
